<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Trainings</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<section class="content">
    <!-- Default box -->
    <div class="container">
        <div class="row" *ngIf="isReadMode">
            <!-- left column -->
            <div class="col-md-12">
                <div class="card">

                    <div class="card-body">

                        <div class="row">
                          <div class="col">
                            <label>Search by Vehicle No.</label> 
                            <ng-select [items]="vehicles" bindLabel="vehicleNo" autofocus bindValue="vehicleNo"
                                       [(ngModel)]="selectedvehicleNo">
                            </ng-select>
                          </div>
                            <div class="col">
                                <label>Search by Title</label>
                                <input [(ngModel)]="seachText" class="form-control">
                            </div>
                            <div class="col">
                                <label>From Date</label> <input [(ngModel)]="fromDate" class="form-control" type="date" (change)="dateChange()">
                            </div>
                            <div class="col">
                                <label>End Date</label> <input [(ngModel)]="endDate" [min]="fromDate" class="form-control" type="date">
                            </div>
                        </div>
                        <br/>
                        <div class="row">
                          <div class="col"><input type="button" class="btn btn-primary" value="Search"
                                  (click)="search()" /> &nbsp;&nbsp;&nbsp;
                              <input type="button" class="btn btn-primary" value="Reset" (click)="reset()" />
                          </div>
                        </div>

                        <br />
                        <div class="row">
                          <div class="col-12">
                              <p style="float:right" *ngIf="userName!='admin' && userName!='itteam'">
                                <!-- <a href="./add-training" class="btn btn-link">Add New Training</a></p> -->
                                <a [routerLink]="['/add-training']" class="btn btn-link">Add New Training</a></p>
                                      <p style="float:right"><input type="button" class="btn btn-link" (click)="back()"
                                          class="btn btn-link" value="Back"></p>
                          </div>                      
                        </div>
                        
                        <div class="row" *ngIf="userRole!='USER'">
                            <div class="col">
                                <label>State Name : {{state_name}}</label>
                            </div>

                            <label for="records">Records per page:</label>
                            <select name="records" id="records" (change)="excelLength($event.target.value)">
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="0">All</option>
                            </select>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button style="float:right" class="btn btn-primary" (click)="exportexcel()">
                              Export To Excel
                            </button>

                        </div>                       

                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <td style="font-weight:bold; ">Sr. No.</td>
                                    <td style="font-weight:bold; ">Vehicle No.</td>
                                    <td style="font-weight:bold; ">Title</td>
                                    <td style="font-weight:bold; ">Description</td>
                                    <td style="font-weight:bold; ">No. Of Trainee</td>
                                    <td style="font-weight:bold; ">Trainer Name</td>
                                    <td style="font-weight:bold; ">Training Date</td>
                                    <td style="font-weight:bold; ">Venue</td>
                                    <td style="font-weight:bold; text-align: center;">Training
                                        Records</td>
                                    <td style="font-weight:bold; text-align: center;">
                                        Action</td>
                                </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let training of trainingsRecordData | paginate : {id: 'pagination1',itemsPerPage: 10, currentPage : p}; let i=index">
                                    <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                    <td>{{ training.vehicleNo }} <span *ngIf="training.vehicleNo==''"> {{training.createdBy }} </span> </td>
                                    <td>{{ training.trainingTitle }}</td>
                                    <td>{{ training.trainingDesc }}</td>
                                    <td>{{ training.noOfTrainees }}</td>
                                    <td>{{ training.trainerName }}</td>
                                    <td>{{ training.trainingDate | date: 'dd-MM-yyyy'}}</td>
                                    <td>{{ training.venue}}</td>
                                    <td><a [routerLink]="['/view-doc/training/',training.trainingId,'/doc']">View</a></td>
                                    <td><input type="button" (click)="deleteTraining(training)" [disabled]="role!='ADMIN' && role!='SO'" value="Delete"
                                    class="btn btn-danger btn-sm"></td>
                              </tr>
                            </tbody>
                        </table>
                        <!-- <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls> -->
                        <pagination-controls id="pagination1" (pageChange)="pageChange($event)" class="float-right"></pagination-controls>

                        <div>
                          <table hidden class="table table-striped table-bordered" id="componentID">
                            <thead>
                                <tr>
                                    <td style="font-weight:bold; ">Sr. No.</td>
                                    <td style="font-weight:bold; ">Vehicle No.</td>
                                    <td style="font-weight:bold; ">Title</td>
                                    <td style="font-weight:bold; ">Description</td>
                                    <td style="font-weight:bold; ">No. Of Trainee</td>
                                    <td style="font-weight:bold; ">Trainer Name</td>
                                    <td style="font-weight:bold; ">Training Date</td>
                                    <td style="font-weight:bold; ">Venue</td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let training of trainingsRecordData | paginate : {id: 'pagination2',itemsPerPage: selectCount, currentPage: p1}; let i=index;">
                                    <!-- <td>{{ itemsPerPage * (p1 - 1) + i + 1 }}</td> -->
                                    <td>{{i+1}}</td>
                                    <td>{{ training.vehicleNo }} <span *ngIf="training.vehicleNo==''"> {{training.createdBy}} </span> </td>
                                    <td>{{ training.trainingTitle }}</td>
                                    <td>{{ training.trainingDesc }}</td>
                                    <td>{{ training.noOfTrainees }}</td>
                                    <td>{{ training.trainerName }}</td>
                                    <td>{{ training.trainingDate | date: 'dd-MM-yyyy'}}</td>
                                    <td>{{ training.venue}}</td>
                                </tr>
                            </tbody>
                            <pagination-controls id="pagination2" (pageChange)="p1 = $event" class="float-right"></pagination-controls>
                          </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="container" *ngIf="isDeleteMode">
            <div class="row">
              
              <div class="col-md-2" style="font-weight:bold">
                <label for="">Training ID :</label>
              </div>
              <div class="col-md-3">
                <label>{{trainingId}}</label>
              </div>

              <div class="col-md-1">

              </div>
              <div class="col-md-2" style="font-weight:bold">
                <label for="">Vehicle No. :</label>

              </div>
              <div class="col-md-4">
                <label>{{vehicleNo}}</label>
              </div>
              

            </div>
            <div class="row">
             <div class="col-md-2" style="font-weight:bold">
                <label for="">Training Title :</label>
              </div>
              <div class="col-md-3">
                <label>{{trainingTitle}}</label>
              </div>

              <div class="col-md-1">

              </div>
              <div class="col-md-2" style="font-weight:bold">
                <label for="">Trainer Name :</label>

              </div>
              <div class="col-md-4">
                <label>{{trainerName}}</label>
              </div>
              

            </div>
            <div class="row">
              <div class="col-md-1" style="font-weight:bold;">
                <label for="">Remark :</label>
              </div>
              <div class="col-md-4">
                <textarea  [(ngModel)]="adminRemark" class="form-control"> </textarea>
              </div>
              <div class="col-md-2">

              </div>

            </div>
            
              <!-- <div class="row">
                <div class="col-md-1" style="font-weight:bold;">
                  <label for="">Remark :</label>
                </div>
                <div class="col-md-4">
                  <textarea  [(ngModel)]="adminRemark" class="form-control"> </textarea>
                </div>
                <div class="col-md-2">

                </div>

              </div> -->
              <br/>
              <div class="row" style="text-align:center;">
                <div class="col"><input type="button" class="btn btn-danger"  value="Delete" (click)="ondeleteTrainingSubmit()" />
                </div>
                <div class="col">
                  <!-- <a href="./list-training/{{stateCode}}" class="btn btn-link">Back</a> -->
                  <!-- <a [routerLink]="['/list-training/',stateCode]" class="btn btn-link">Back</a> -->
                  <a (click)="backDeleteStateWiseTrainingData()" class="btn btn-link">Back</a>
                </div>
                
              </div>
              <!-- <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
                <strong>Success!</strong> Your data has been deleted successfully.
                <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div> -->
              
            
          </div>
    </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>